<template>
  <section>
    <top-menu/>

    <section>
      <page-header :headerName="'Avisos e Campanhas'" :showBtn="true" :btnName="'Nova liberação'"
                   :btnRoute="'/avisos-e-campanhas/liberacoes/nova'" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">

                <feature-window-tabs :current="'windows'"/>

                <!--
                  Enquanto um banco nao responder, os contadores sao um PISO e nao
                  um total: as empresas daquele banco nao entraram na conta. Dizer
                  isso e obrigatorio, senao "3 de 10 ligadas" parece um problema de
                  ativacao quando e so um banco fora do ar.
                -->
                <div class="fw-warn" v-if="shardsFailed.length">
                  Números incompletos: {{ shardsFailed.join(', ') }} não responderam.
                  <div v-for="failure in shardFailures" :key="failure.shardId" class="fw-warn__reason">
                    {{ failure.shardName || failure.shardId }}: {{ failure.error || 'sem detalhe' }}
                  </div>
                </div>

                <filter-bar v-if="!loadFailed && items.length" :active="filtersActive" @clear="clearFilters">
                  <date-range-filter label="Criada em" :from.sync="filters.criadoDe" :to.sync="filters.criadoAte"/>
                  <date-range-filter label="Período ativo" :from.sync="filters.ativoDe" :to.sync="filters.ativoAte"/>
                  <div class="fw-filter-features">
                    <span class="fw-filter-features__label">Funcionalidades</span>
                    <multiselect :value="selectedFeatureOptions" :options="featureOptions"
                                 :multiple="true" track-by="value" label="label"
                                 :close-on-select="false" :show-labels="false"
                                 :limit="1" :limit-text="limitText"
                                 placeholder="Todas" @input="setFeatures"/>
                  </div>
                  <filter-select label="Situação" v-model="filters.situacao" :options="statusOptions"/>
                  <filter-select label="Responsável" v-model="filters.responsavel" :options="ownerOptions"/>
                </filter-bar>

                <paged-table class="fw-table" v-if="!loadFailed && visibleItems.length"
                             :rows="visibleItems" storage-key="feature-window-list" v-slot="{ rows }">
                  <thead>
                  <tr>
                    <th>Funcionalidade</th>
                    <th style="width:210px">Período</th>
                    <th style="width:100px">Empresas</th>
                    <th style="width:170px">Ativações ligadas / encerradas</th>
                    <th style="width:130px">Situação</th>
                    <th style="width:170px">Criada por</th>
                    <th style="width:110px">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in rows" :key="item.id">
                    <td>
                      <span v-for="name in (item.featureNames || []).slice(0, 3)" :key="name" class="fw-feature-chip">{{ name }}</span>
                      <span class="fw-sub" v-if="(item.featureNames || []).length > 3">
                        +{{ item.featureNames.length - 3 }}
                      </span>
                      <div class="fw-notes" v-if="item.notes">{{ item.notes }}</div>
                    </td>
                    <td>{{ period(item) }}</td>
                    <td>{{ item.targeted }}</td>
                    <td>
                      {{ item.activated }} / {{ item.deactivated }}
                      <!--
                        "Já possuíam" NAO entra em Ligadas: essas empresas nao
                        receberam nada da liberacao e nao serao desligadas no fim.
                        Somar as duas contaria como entrega o que a empresa ja tinha.
                      -->
                      <span class="fw-sub" v-if="item.alreadyHad">
                        · {{ item.alreadyHad }} já possuíam
                      </span>
                      <span class="fw-sub is-bad" v-if="item.failed">
                        · {{ item.failed }} com falha
                      </span>
                    </td>
                    <td>
                      <span class="fw-chip" :class="statusClass(item)">{{ statusLabel(item) }}</span>
                    </td>
                    <td>{{ item.createdByName || '—' }}</td>
                    <!-- Mesmos icones e mesma ordem da aba Campanhas (broadcastList.vue).
                         Editar e cancelar so onde ainda ha o que mudar: janela
                         encerrada ou cancelada nao liga nem desliga mais nada. -->
                    <td class="fw-actions">
                      <router-link class="fw-actions__link" :to="engagementRoute(item)"
                                   v-tooltip.top-center="'Ver engajamento'">
                        <i class="fa fa-bar-chart" aria-hidden="true"></i>
                      </router-link>
                      <i class="fa fa-pencil" aria-hidden="true"
                         v-if="isEditable(item)"
                         v-tooltip.top-center="'Editar liberação'"
                         v-on:click.stop="edit(item)"></i>
                      <i class="fa fa-trash fw-actions__danger" aria-hidden="true"
                         v-if="isEditable(item)"
                         v-tooltip.top-center="'Cancelar liberação'"
                         v-on:click.stop="cancel(item)"></i>
                    </td>
                  </tr>
                  </tbody>
                </paged-table>

                <p class="fw-no-match" v-else-if="!loadFailed && items.length">
                  Nenhum resultado para os filtros selecionados.
                  <a href="#" @click.prevent="clearFilters">Limpar filtros</a>
                </p>

                <!--
                  Falha de leitura nao pode virar "nenhuma liberação": as duas
                  telas nao tem linha nenhuma e significam coisas opostas. Mesma
                  separacao que broadcastList.vue faz com loadFailed.
                -->
                <p class="fw-warn" v-else-if="loadFailed">
                  Não foi possível carregar as liberações.
                </p>

                <empty-state v-else-if="!loading"/>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <full-loading v-if="loading" transparent/>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pagedTable from "../../components/default/pagedTable.vue";
import filterBar from "../../components/default/filterBar.vue";
import filterSelect from "../../components/default/filterSelect.vue";
import dateRangeFilter from "../../components/default/dateRangeFilter.vue";
import Multiselect from "vue-multiselect";
import { listFilterState } from "../../components/default/listFilterState";
import {
  createdWithin, matchesAny, matchesOwner, overlapsPeriod, ownerOptions,
} from "../../components/default/listFilters";
import emptyState from "../../components/layouts/emptyState.vue";
import swal from "sweetalert";
import featureWindowTabs from "./featureWindowTabs.vue";
import { isNoCrossToken, requestApiV2 } from "../broadcast/broadcastApiV2Auth";
import { FEATURE_WINDOWS, FEATURE_WINDOW_CANCEL } from "../../../../urlConfig";

/** Valor do filtro na URL -> literal de FeatureWindowStatus e rotulo da tela. */
const STATUS_KEYS = {
  agendada: { server: 'Scheduled', label: 'Agendada' },
  ativa: { server: 'Active', label: 'Ativa' },
  finalizada: { server: 'Ended', label: 'Finalizada' },
  cancelada: { server: 'Cancelled', label: 'Cancelada' },
};

export default {
  name: "feature-window-list",
  components: {
    topMenu, pageHeader, fullLoading, emptyState, featureWindowTabs, pagedTable,
    filterBar, filterSelect, dateRangeFilter, Multiselect,
  },
  mixins: [listFilterState('feature-window-list', {
    criadoDe: '', criadoAte: '', ativoDe: '', ativoAte: '', funcionalidades: [], situacao: '', responsavel: '',
  })],
  data() {
    return {
      loading: false,
      loadFailed: false,
      items: [],
      shardsFailed: [],
      shardFailures: [],
    };
  },
  created() {
    this.load();
  },
  computed: {
    /**
     * Funcionalidades que aparecem em alguma liberacao da lista, de A a Z.
     * featureNames vem na mesma ordem de featureTypes (FeatureWindowAdminService).
     */
    featureOptions() {
      const seen = {};
      const options = [];
      this.items.forEach((item) => {
        (item.featureTypes || []).forEach((type, index) => {
          if (seen[type]) return;
          seen[type] = true;
          options.push({ value: type, label: (item.featureNames || [])[index] || String(type) });
        });
      });
      return options.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
    },
    /** A URL guarda texto; o seletor quer os objetos das opcoes. */
    selectedFeatureOptions() {
      const ids = this.filters.funcionalidades;
      return this.featureOptions.filter((o) => ids.indexOf(String(o.value)) !== -1);
    },
    statusOptions() {
      return Object.keys(STATUS_KEYS).map((key) => ({ value: key, label: STATUS_KEYS[key].label }));
    },
    ownerOptions() {
      return ownerOptions(this.items);
    },
    /** Filtra antes de paginar: o "1–10 de N" do rodape ja conta so o que passou. */
    visibleItems() {
      const f = this.filters;
      const features = f.funcionalidades.map(Number);
      const status = f.situacao && STATUS_KEYS[f.situacao];
      return this.items.filter((item) =>
        createdWithin(item.createdAt, f.criadoDe, f.criadoAte) &&
        overlapsPeriod(item.startsAt, item.endsAt, f.ativoDe, f.ativoAte) &&
        matchesAny(item.featureTypes, features) &&
        (!f.situacao || (status && item.status === status.server)) &&
        matchesOwner(item.createdByName, f.responsavel));
    },
  },
  methods: {
    limitText(count) {
      return '+' + count;
    },
    setFeatures(options) {
      this.filters.funcionalidades = (options || []).map((o) => String(o.value));
    },
    load() {
      this.loading = true;
      this.loadFailed = false;

      requestApiV2('GET', FEATURE_WINDOWS)
        .then((response) => {
          const data = (response && response.data) || {};
          this.items = data.items || [];
          this.shardsFailed = data.shardsFailed || [];
          this.shardFailures = data.shardFailures || [];
          this.loadFailed = false;
        })
        .catch(() => {
          this.items = [];
          this.shardsFailed = [];
          this.shardFailures = [];
          this.loadFailed = true;
        })
        .then(() => {
          this.loading = false;
        });
    },
    /**
     * Editar e cancelar so fazem sentido enquanto a liberacao pode ligar ou
     * desligar alguma coisa. Oferecer os dois numa janela ja encerrada
     * prometeria uma acao sem efeito.
     */
    isEditable(item) {
      return item.status === 'Scheduled' || item.status === 'Active';
    },
    edit(item) {
      this.$router.push('/avisos-e-campanhas/liberacoes/' + item.id + '/editar');
    },
    engagementRoute(item) {
      return '/avisos-e-campanhas/liberacoes/' + item.id + '/engajamento';
    },
    cancel(item) {
      swal({
        title: "Cancelar a liberação?",
        text: "A funcionalidade será desligada agora nas empresas que a receberam por esta liberação, " +
              "e o aviso dela sai do ar. Empresas que já possuíam a funcionalidade não são afetadas. " +
              "O histórico é preservado.",
        icon: "warning",
        buttons: ["Voltar", "Cancelar liberação"],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;

        this.loading = true;

        requestApiV2('POST', FEATURE_WINDOW_CANCEL(item.id))
          .then((response) => {
            const data = (response && response.data) || {};

            // O numero vem do SERVIDOR, nao da contagem que a tela tinha: o que
            // foi realmente desligado e o que os bancos confirmaram.
            const done = "Liberação cancelada. " + (data.deactivated || 0) +
              " empresa(s) desligada(s).";

            // Cancelar o aviso junto pode falhar sem desfazer o encerramento.
            if (data.broadcastWarning) {
              swal("Atenção", done + "\n\n" + data.broadcastWarning, "warning");
            } else {
              swal("Aviso", done, "success");
            }
          })
          .catch((error) => {
            swal("Ops...", this.errorText(error, 'cancelar a liberação'), "error");
          })
          .then(() => {
            this.loading = false;
            this.load();
          });
      });
    },
    errorText(error, action) {
      const status = error && error.response && error.response.status;

      if (isNoCrossToken(error))
        return 'Saia e entre novamente no Master para autenticar na API v2.';

      if (status === 404)
        return 'Endpoint não encontrado (404). A API ainda não está publicada neste ambiente.';

      if (status === 401 || status === 403)
        return 'Sem permissão (' + status + '). É necessário um usuário operador da plataforma.';

      return 'Não foi possível ' + action + (status ? ' (' + status + ')' : '') + '.';
    },
    period(item) {
      return this.date(item.startsAt) + ' até ' + this.date(item.endsAt);
    },
    date(value) {
      if (!value) return '';
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? '' : parsed.toLocaleDateString('pt-BR');
    },
    /**
     * Os literais vem do servidor (FeatureWindowStatus). A tela so traduz: a
     * situacao e derivada das datas num lugar so, para as duas pontas nao
     * discordarem sobre o que e "ativa".
     */
    statusLabel(item) {
      if (item.status === 'Cancelled') return 'Cancelada';
      if (item.status === 'Scheduled') return 'Agendada';
      if (item.status === 'Active') return 'Ativa';
      return 'Finalizada';
    },
    statusClass(item) {
      if (item.status === 'Active') return 'is-live';
      if (item.status === 'Cancelled') return 'is-cancelled';
      return 'is-muted';
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.fw-table { margin-bottom: 12px; }

.fw-no-match { margin: 8px 0 16px; font-size: 13px; color: #4e5560; }
.fw-no-match a { margin-left: 6px; color: #1b59f8; }

.fw-filter-features { width: 260px; }
.fw-filter-features__label { display: block; margin-bottom: 4px; font-size: 12px; color: #4e5560; }
.fw-filter-features >>> .multiselect,
.fw-filter-features >>> .multiselect__tags { min-height: 34px; font-size: 12px; }
.fw-filter-features >>> .multiselect__tags { padding-top: 6px; border-color: #ccc; border-radius: 4px; }
.fw-filter-features >>> .multiselect__placeholder { margin-bottom: 6px; padding-top: 0; font-size: 12px; }
.fw-filter-features >>> .multiselect__select { height: 32px; }

.fw-notes {
  font-size: 11px;
  color: #8f96a3;
  margin-top: 2px;
}

.fw-sub {
  font-size: 11px;
  color: #8f96a3;
}
.fw-sub.is-bad { color: #ff445d; }

/* Mesmo desenho das acoes de broadcastList.vue. */
.fw-actions__link { color: #1b59f8; margin-right: 10px; }
.fw-actions__link:hover, .fw-actions__link:focus { color: #1b59f8; }

.fw-actions { white-space: nowrap; }
.fw-actions i {
  margin-right: 12px;
  color: #4e5560;
  cursor: pointer;
}
.fw-actions i:last-child { margin-right: 0; }
.fw-actions i.fw-actions__danger { color: #ff445d; }

.fw-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}
.fw-chip.is-live { background: #ecf9ef; color: #12b937; }
.fw-chip.is-cancelled { background: #fff0f2; color: #ff445d; }
.fw-chip.is-muted { background: #f4f4f5; color: #4e5560; }

/*
  Nome diferente de .fw-chip (usado acima para Situação) de proposito: as duas
  classes compartilhariam padding/raio/font-size por cascata se tivessem o
  mesmo nome, corrompendo visualmente o chip de Situação.
*/
.fw-feature-chip {
  display: inline-block;
  margin: 0 4px 4px 0;
  padding: 2px 8px;
  border: 1px solid #E6E9EC;
  border-radius: 10px;
  font-size: 12px;
}

.fw-warn__reason { margin-top: 4px; font-weight: 500; color: #8a6d00; }
.fw-warn {
  background: #fff9eb;
  color: #ffb800;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/featureWindow/featureWindowList.vue